/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const UserTypeDropdownV2 = ({
    helperText,
    error,
    setFormValues,
    isFilter,
    selectedUserType,
    setSelectedUserType,
}) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const handleValue = (value) => {
        if (value === t("page")) return "page";
        else if (value === t("driver")) return "driver";
    };

    const options = [t("page"), t("driver")];

    useEffect(() => {
        if (!selectedUserType && !isFilter) {
            setSelectedUserType(options[0]);
            setFormValues &&
                setFormValues((prevValues) => ({
                    ...prevValues,
                    userType: handleValue(options[0]) || null,
                }));
        }
    }, []);

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={options}
                getOptionLabel={(option) => option}
                value={selectedUserType || ""}
                onChange={(event, newValue) => {
                    setSelectedUserType(newValue);
                    setFormValues &&
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            userType: handleValue(newValue) || null,
                        }));
                }}
                renderInput={(params) => (
                    <Box>
                        {!isFilter && (
                            <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("customerType")}
                            </p>
                        )}

                        <TextField
                            {...params}
                            variant={isFilter ? "standard" : "outlined"}
                            fullWidth
                            placeholder={isFilter ? t("customerType") : t("chooseCustomerType")}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter
                                        ? "transparent"
                                        : theme.palette.customGrey.insideInput,
                                    padding: "6px 8px",
                                },
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor:
                                            theme.palette.customGrey.borderInput,
                                    },
                                    "&:hover fieldset": {
                                        borderColor:
                                            theme.palette.customGrey.borderInput,
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: theme.palette.text.primary,
                                    padding: "6px 8px",
                                    "&::placeholder": {
                                        fontSize: "14px",
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
};

export default UserTypeDropdownV2;
